import { useEffect } from "react";

export type HideSplashOptions = {
    /** fade even when the splash is still blank, over this many ms */
    fadeMs?: number;
    /** skip the short hold that keeps a splash that just appeared from flickering */
    now?: boolean;
};

declare global {
    interface Window {
        hideSplash?: (options?: HideSplashOptions | true) => number | undefined;
    }
}

/**
 * Fades out the loading splash from index.html. Safe to call any number of times.
 * Returns how many ms the splash still stays before its fade starts.
 */
export function hideSplash(options?: HideSplashOptions): number {
    return window.hideSplash?.(options) ?? 0;
}

/**
 * Put next to a page inside its Suspense boundary: it mounts only once that page has
 * loaded and rendered, and then hands the screen over from the splash.
 */
export function SplashDone() {
    useEffect(() => {
        hideSplash();
    }, []);
    return null;
}
